import {
  DownloadOutlined,
  RedoOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Button, Input, Popconfirm, Space, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AudioActions from "../../../actions/audio";
import { AudioT } from "../../../constants/ActionTypes/audio-action-types";
import useWindowDimensions from "../../../constants/sizecheck";
import { RootStore } from "../../../store/store";
import "../../formating/content.css";
import { downloadContent } from "./audio";
import type { InputRef } from "antd";
import type { ColumnType } from "antd/es/table";

export default function DeletedAudios({ showDeletedModal }: any) {
  const dispatch = useDispatch();
  const propAudios = useSelector(
    (state: RootStore) => state.audioReducer.deletedAudios
  );
  const propStatus = useSelector(
    (state: RootStore) => state.audioReducer.status
  );
  const [loaded, setLoaded] = useState<boolean>(() => false);
  const { width } = useWindowDimensions();
  const [searchedColumn, setSearchedColumn] = useState(() => "");
  const searchInput = useRef<InputRef>(null);

  useEffect(() => {
    const fetch = async () => {
      if (showDeletedModal) {
        try {
          await dispatch(AudioActions.getAllDeletedAudio());
        } catch (err) {
          console.log(err);
        }
      }
    };
    fetch();
    if (propStatus) {
      setLoaded(true);
    }
  }, [dispatch, showDeletedModal]);

  const getDeletedAudios = async () => {
    setLoaded(false);
    try {
      await dispatch(AudioActions.getAllDeletedAudio());
      if (propStatus) {
        setLoaded(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const restoreDeletedAudio = async (record: AudioT) => {
    await dispatch(AudioActions.restoreAudio(record.id.toString()));
    await getDeletedAudios();
  };

  type DataIndex = keyof AudioT;

  const handleSearch = (
    confirm: (param?: any) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchedColumn(dataIndex);
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    title: string
  ): ColumnType<AudioT> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div className="searchPadding">
        <Input
          ref={searchInput}
          placeholder={`Keress ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(confirm, dataIndex)}
          className="searchInput"
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            className="searchButton"
          >
            Keresés
          </Button>
          <Button
            onClick={() => {
              setSelectedKeys([]);
              handleSearch(confirm, dataIndex);
            }}
            size="small"
            className="searchButton"
          >
            Visszaállítás
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    render: (text) => (searchedColumn === dataIndex ? text : text),
  });

  const columns = [
    {
      title: "Audió neve",
      key: "name",
      dataIndex: "name",
      ...getColumnSearchProps("name", "nevet"),
      sorter: (a: AudioT, b: AudioT) => {
        return a.name.localeCompare(b.name);
      },
    },
    {
      title: "Eredeti név",
      key: "originalName",
      dataIndex: "originalName",
      ...getColumnSearchProps("originalName", "eredeti nevet"),
    },
    {
      title: "Audió mérete",
      key: "fileSize",
      render: (text: string, record: AudioT) => {
        return `${record.fileSize} KB`;
      },
    },
    {
      title: "Könyv",
      key: "fileSize",
      render: (text: string, record: AudioT) => {
        return record.book?.map((b) => {
          if (!b.deleted) return b.title + ", ";
        });
      },
    },
    {
      title: "Létrehozva",
      key: "created",
      render: (text: string, record: AudioT) => {
        return new Date(record.created).toLocaleDateString();
      },
    },
    {
      title: "Letöltés",
      key: "download",
      render: (text: string, record: AudioT) => {
        return (
          <Space size="middle">
            <Button onClick={() => downloadContent(record)}>
              <DownloadOutlined />
            </Button>
          </Space>
        );
      },
    },
    {
      title: "Visszaállítás",
      key: "restore",
      render: (text: string, record: AudioT) => {
        return (
          <div>
            <Popconfirm
              title="Biztosan vissza akarod állítani ezt az audiót?"
              okText="Igen"
              cancelText="Mégsem"
              onConfirm={() => restoreDeletedAudio(record)}
            >
              <Button type="primary">
                <RedoOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <h1 className="title">
        <strong>Törölt audiók</strong>
      </h1>
      <Table
        columns={columns}
        rowKey="id"
        dataSource={propAudios}
        loading={!loaded && !propAudios}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 10,
          showSizeChanger: false,
        }}
        scroll={{ y: width / 2 }}
      />
    </div>
  );
}
